const PHONE_NUMBER = /^(09\d{9})$/g
const NAME = /^[.ـa-zA-Zا-ی ]+$/
const TEXT_INPUT = /^[a-zA-Zا-ی_0-9 ۰-۹]+$/
const FA_NAME = /^[ا-ی ]+$/
const URL = /(https?:\/\/[^\s]+)/g
const BASE64 = /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/




const REGEX = {
    PHONE_NUMBER,
    NAME,
    FA_NAME,
    URL,
    BASE64,
    TEXT_INPUT
}

export default REGEX;